import { useAuth } from './use-auth';
import { useWallet } from './use-wallet';
import { isBoundWalletMismatch } from '@/client/utils/wallet-address';
import { useMemo } from 'react';

/**
 * Wrong-wallet guard for any wallet-signing action (ADR-051 D2).
 *
 * A DID user binds ONE wallet (eoa_address, immutable). If a DIFFERENT wallet is
 * active and signs a trade/claim, the AMM `deposit` mints option tokens to the
 * connected wallet while the server credits the uid — positions split from the
 * uid-keyed view and a later claim from the bound wallet finds no tokens.
 *
 * `mismatch` is true ONLY when a bound wallet AND a connected wallet both exist
 * and differ. It never fires for: DID pre-link (no bound wallet), not-connected,
 * or SIWE sessions (connected === bound). Single source of truth:
 * `isBoundWalletMismatch`.
 */
export const useBoundWalletGuard = () => {
  const { linkedWallet } = useAuth();
  const { address } = useWallet();
  const mismatch = useMemo(() => isBoundWalletMismatch(linkedWallet, address), [linkedWallet, address]);
  return { mismatch, boundWallet: linkedWallet ?? null, connected: address ?? null };
};
